import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import i18n from '../locales/i18n';
import NewsBox from './NewsBox';

/* eslint no-underscore-dangle: 0 */

export default function News({ newsList }) {
  const { t } = useTranslation();
  const newsL = newsList.sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <div className="section news">
      <h2 className="newsTitle">{t('news')}</h2>
      <div className="scrollbar" id="style-1">
        {newsL.map((news) => (
          <NewsBox
            key={news._id}
            image={news.image}
            title={news.title1[i18n.language]}
            link={news.link}
            date={news.date}
          />
        ))}
      </div>
    </div>
  );
}

News.propTypes = {
  newsList: PropTypes.instanceOf(Array).isRequired,
};
